import ActiveProfile from './ActiveProfile'
import { USER_TYPE_CUSTOMER_PERSON } from '@/constants/user/roles'
import Skill from '@/models-ts/Skill'

export default class EmployerProfile extends ActiveProfile {
  type: typeof USER_TYPE_CUSTOMER_PERSON
  description: string | null
  website: string | null
  relations: {
    Country: Array<{ id: number; name: string }> | null
    Skill: Array<Skill> | null
    Currency: Array<{ id: number; name: string }> | null
  }

  constructor(data: Partial<EmployerProfile>) {
    super(data as LX.ActiveProfile)
    Object.assign(this, {
      type: data.type,
      description: data.description,
      website: data.website,
      relations: {
        Country: data.relations?.Country || [],
        Skill: data.relations?.Skill || [],
        Currency: data.relations?.Currency || [],
      },
    })
  }

  static fromServer(data: LX.EmployerProfile) {
    return new EmployerProfile({
      type: USER_TYPE_CUSTOMER_PERSON,
      description: data.description || '',
      website: data.website || '',
      relations: {
        Country: data.relations?.Country || [],
        Skill: (data.relations?.Skill || []).map(Skill.fromServer),
        Currency: data.relations?.Currency || [],
      },
      first_name: data.first_name,
      last_name: data.last_name,
      id: data.id || data.user_id,
    })
  }
}
